/**
 * Minimal toast store — single active toast at a time.
 * Adapted from shadcn's use-toast pattern, simplified for our needs.
 */
import * as React from 'react';

interface ToastState {
	id: number;
	message: string;
	tone: 'default' | 'success' | 'destructive';
	open: boolean;
}

let listeners: Array<(state: ToastState | null) => void> = [];
let activeToast: ToastState | null = null;
let nextId = 1;

function notify() {
	for (const l of listeners) l(activeToast);
}

export function toast(message: string, tone: ToastState['tone'] = 'success') {
	activeToast = { id: nextId++, message, tone, open: true };
	notify();
	setTimeout(() => {
		activeToast = null;
		notify();
	}, 2400);
}

export function useToast() {
	const [state, setState] = React.useState<ToastState | null>(activeToast);
	React.useEffect(() => {
		listeners.push(setState);
		return () => {
			listeners = listeners.filter(l => l !== setState);
		};
	}, []);
	return { toast: state };
}
